import { useContext } from 'react';
import { UserDataContext } from '../../contexts';

import './greetings.css';

function Greetins() {
  const {
    userInfo,
  } = useContext(UserDataContext);
  const { name, isPlural = false } = userInfo;

  return (
    <section className="greeting-section">
      <div>
        <div className="heart-container">
          <img src="/images/heart-1.svg" alt="" className="heart-1" />
          <div className="greeting-text">
            Привет, {name ?? 'друг'}!<br />
            Приглашаем {isPlural ? 'вас' : 'тебя'} на<br />
            нашу свадьбу!
          </div>
        </div>
      </div>


      <div className="photo-container">
        <img src="/images/we-1.png" alt="Пара 1" className="photo photo-top" />
        <img src="/images/we-2.jpg" alt="Пара 2" className="photo photo-bottom" />
      </div>
    </section>
  );
}

export default Greetins;
